import { operatorsNull } from "../../DatagridFilters/DatagridFilters";
export const isToApplyFilter = (prevState, state) => {
  //Remove filter scenario
  if (prevState.length > state.length) {
    return true;
  }
  const result = (state || []).some((item, index) => {
    const previousItem = prevState[index];
    const {
      operator,
      filters
    } = item;
    const hasValue = (filters || []).find(item => item.value);

    // Different filters values
    if (hasValue && JSON.stringify(previousItem?.filters) !== JSON.stringify(filters)) {
      return true;
    }

    // Different Operator when exists value or if its an null operator
    if ((hasValue || operatorsNull.includes(operator)) && previousItem?.operator !== operator) {
      return true;
    }
    return false;
  });
  return result;
};
export const buildAvailableFilters = (availableFilters, columnsObj, i18n) => {
  const columnsWithFilters = {
    ...columnsObj
  };
  (availableFilters || []).forEach(item => {
    if (columnsWithFilters[item.name]) {
      columnsWithFilters[item.name] = {
        ...columnsWithFilters[item.name],
        disableColumnMenu: false,
        filterable: true
      };
    }
  });
  return {
    columnsWithFilters
  };
};